import { createRelationalReportFromBaseReport } from 'reporting-snowflake/relational/utils/report-utils';
import PlatformReportResolver from 'reporting-ui-components/components/PlatformReport/PlatformReportResolver';
//@ts-expect-error Untyped dependency
import { createDefaultReportOptions } from 'reporting-ui-components/components/snowflake/report-options';
import { SelectedReports } from 'reporting-action-components/reportingActions/exportReport/ExportReportButton';
import { SRVDatasetTableActionsBar } from '../../common/dataset-tables/SRVDatasetTableActionsBar';
import { useSnowflakeSummaryTable } from './useSnowflakeSummaryTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SRVSummarizedTableSnowflakeReport = ({
  previewReport,
  suppressActionsBar = false
}) => {
  const report = useSnowflakeSummaryTable(previewReport);
  if (!report) {
    return null;
  }
  const initialReportOptions = createDefaultReportOptions(createRelationalReportFromBaseReport(report), undefined);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!suppressActionsBar && /*#__PURE__*/_jsx(SRVDatasetTableActionsBar, {
      report: report,
      selectedReport: SelectedReports.summarizedTable
    }), /*#__PURE__*/_jsx(PlatformReportResolver, {
      lazyReportResolve: false,
      report: report,
      initialReportOptions: initialReportOptions,
      useInlineLabels: false,
      enableReportResolveUsageTracking: false
    })]
  });
};